import { defineMessages } from 'react-intl';

export default defineMessages({
    bundleConfirmation: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Bundle Confirmation',
        defaultMessage: 'Bundle Confirmation'
    },
    thankYou: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Thank You for choosing us',
        defaultMessage: 'Thank You for choosing us'
    },
    printConfirmation: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Print confirmation',
        defaultMessage: 'Print confirmation'
    },
    goToAccount: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.GO TO ACCOUNT',
        defaultMessage: 'GO TO ACCOUNT'
    },
    congratulationText: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.These policies have been successfully issued. If there is additional information needed from the customer, an Important Reminder box will display below. When shown, please advise the customer of additional information needed from them.',
        defaultMessage: 'These policies have been successfully issued. If there is additional information needed from the customer, an Important Reminder box will display below. When shown, please advise the customer of additional information needed from them.'
    },
    importantRemindersForYou: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Important reminders for you',
        defaultMessage: 'Important reminders for you'
    },
    watchEmailForMoreInfo: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Watch your email inbox for more information',
        defaultMessage: 'Watch your email inbox for more information'
    },
    rememberToNotifyCarrier: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Remember to notify your current carrier of your new policy with us so they can cancel your policy on the effective date listed above',
        defaultMessage: 'Remember to notify your current carrier of your new policy with us so they can cancel your policy on the effective date listed above'
    },
    policyDetailsUppercase: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.POLICY DETAILS',
        defaultMessage: 'POLICY DETAILS'
    },
    productNamePolicy: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.productName Policy',
        defaultMessage: '{ productName } Policy'
    },
    effectiveDate: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Effective Date: ',
        defaultMessage: 'Effective Date: '
    },
    expirationDate: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Expiration Date: ',
        defaultMessage: 'Expiration Date: '
    },
    paymentMethodUppercase: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.PAYMENT METHOD',
        defaultMessage: 'PAYMENT METHOD'
    },
    paymentMethod: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Payment Method: ',
        defaultMessage: 'Payment Method: '
    },
    downPaymentMethodUppercase: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.DOWN PAYMENT',
        defaultMessage: 'DOWN PAYMENT'
    },
    paymentAmount: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Payment Amount: ',
        defaultMessage: 'Payment Amount: '
    },
    paymentDate: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Payment Date: ',
        defaultMessage: 'Payment Date: '
    },
    confirmationNumber: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Confirmation #: ',
        defaultMessage: 'Confirmation #: '
    },
    insuredUppercase: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.INSURED',
        defaultMessage: 'INSURED'
    },
    coInsuredUppercase: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.CO-INSURED',
        defaultMessage: 'CO-INSURED'
    },
    vehiclesUppercase: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.VEHICLES',
        defaultMessage: 'VEHICLES'
    },
    propertyAddressUppercase: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.PROPERTY ADDRESS',
        defaultMessage: 'PROPERTY ADDRESS'
    },
    congratulationAlertText: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Congratulations! The bundled policies have been successfully issued.',
        defaultMessage: 'Congratulations! The bundled policies have been successfully issued.'
    },
    retrievingPolicies: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Retrieving policies...',
        defaultMessage: 'Retrieving policies...',
    },
    endingIn: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.ending in x',
        defaultMessage: 'ending in {cardNumber}',
    },
    auto: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Auto',
        defaultMessage: 'Auto',
    },
    umbrella: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Umbrella',
        defaultMessage: 'Umbrella',
    },
    namedNonOwner: {
        id: 'ml.gateway.quoteandbind.common.bundleConfirmation.Named Non-Owner',
        defaultMessage: 'Named Non-Owner',
    },
    
    
})